.container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 16px;
  background: #ececed;
  font-family: Oxygen, sans-serif;
}

.sort {
  display: flex;
  align-items: center;
  gap: 8px;
}

.sortLabel {
  font-size: 14px;
  font-weight: 700;
  color: #222;
  white-space: nowrap;
}

.container .sortMenu {
  padding: 7px 30px 7px 12px;
  font-size: 14px;
  color: #222;
  background-color: #fff;
  border: 1px solid #cfcfcf;
  border-radius: 2px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23222' stroke-width='1.5'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 10px;
}

.container .sortMenu:hover,
.container .sortMenu:focus {
  background-color: #fff;
  border-color: #999;
}

/* Mobile: FILTER | SORT BY buttons (hidden on desktop). */
.mobileBar {
  display: none;
}

@media (max-width: 767px) {
  .container {
    display: none;
  }

  .mobileBar {
    display: flex;
    align-items: stretch;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 6px;
    overflow: hidden;
    font-family: Oxygen, sans-serif;
  }

  .mobileButton {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 14px 12px;
    font-family: inherit;
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #222;
    background: none;
    border: none;
    cursor: pointer;
  }

  /* Divider between the two buttons. */
  .mobileSort {
    position: relative;
    border-left: 1px solid #ddd;
  }

  .mobileIcon {
    width: 16px;
    height: 16px;
    flex: 0 0 auto;
  }

  /* Native select overlaid on the SORT BY button to open the options. */
  .mobileSelect {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    opacity: 0;
    border: none;
    font-size: 16px;
    cursor: pointer;
  }
}
